import { useState } from "react";

import { SuggestEditDialog } from "@components/QaReview/PeerReview/SuggestEditDialog";
import { useCreateComment } from "@components/QaReview/hooks/useCreateComment";
import { useReviewFields } from "@components/QaReview/hooks/useReviewFields";
import { useReviewSession } from "@components/QaReview/hooks/useReviewSession";

export const SuggestEditDialogHost: React.FC = () => {
  const { state, dispatch } = useReviewSession();
  const fieldsById = useReviewFields();
  const createComment = useCreateComment();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const field = state.suggestEditFieldId ? fieldsById[state.suggestEditFieldId] : null;
  const close = () => dispatch({ type: "setSuggestEditField", fieldId: null });

  if (!field) return null;

  return (
    <SuggestEditDialog
      key={field.id}
      field={field}
      isSubmitting={isSubmitting}
      onCancel={close}
      onSubmit={(body, proposedValue, baseValue) => {
        setIsSubmitting(true);
        createComment({ fieldId: field.id, proposedValue, baseValue }, body, {
          onCreated: () => dispatch({ type: "closeSuggestEdit", fieldId: field.id }),
          onSettled: () => setIsSubmitting(false),
        });
      }}
    />
  );
};
